// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yEPU","field":"styles_field__3Bt-U","fieldCol":"styles_fieldCol__KGAbK","diffCol":"styles_diffCol__1PqXe","diff":"styles_diff__830qW"};